import styled, { css } from "styled-components";
import mainImage01 from "../../img/main/main_image01.jpg";
import mainImage02 from "../../img/main/main_image02.jpg";
import mainImage03 from "../../img/main/main_image03.jpg";
import mainImage04 from "../../img/main/main_image04.jpg";
import mainImage05 from "../../img/main/main_image05.jpg";
import mainImage06 from "../../img/main/main_image06.jpg";
import mainImage07 from "../../img/main/main_image07.jpg";
import mbMainImage01 from "../../img/main/mb_main_image01.jpg";
import mbMainImage02 from "../../img/main/mb_main_image02.jpg";
import mbMainImage03 from "../../img/main/mb_main_image03.jpg";
import mbMainImage04 from "../../img/main/mb_main_image04.jpg";
import mbMainImage05 from "../../img/main/mb_main_image05.jpg";
import mbMainImage06 from "../../img/main/mb_main_image06.jpg";
import mbMainImage07 from "../../img/main/mb_main_image07.jpg";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";
import { FadeInDiv, FadeInImg } from "../../styles/fadeIn";
import mobileLogo from "../../img/main/mobile_logo.png";

export default function HomeInfo() {
  // 각 요소별로 훅을 따로 호출
  const fadeTitle = useScrollFadeIn();
  const fadeContentLeft = useScrollFadeIn();
  const fadeContentRight = useScrollFadeIn();
  // 이미지 fade 훅들
  const fadeImg01 = useScrollFadeIn();
  const fadeImg02 = useScrollFadeIn();
  const fadeImg03 = useScrollFadeIn();
  const fadeImg04 = useScrollFadeIn();
  const fadeImg05 = useScrollFadeIn();
  const fadeImg06 = useScrollFadeIn();
  const fadeImg07 = useScrollFadeIn();
  const fadeMbImg01 = useScrollFadeIn();
  const fadeMbImg02 = useScrollFadeIn();
  const fadeMbImg03 = useScrollFadeIn();
  const fadeMbImg04 = useScrollFadeIn();
  const fadeMbImg05 = useScrollFadeIn();
  const fadeMbImg06 = useScrollFadeIn();
  const fadeMbImg07 = useScrollFadeIn();

	return (
        <IntroSection className="intro">
            <IntroGrid className="intro-sec01">
                <IntroText $left className="intro-text left">
                    <IntroTitle className="intro-title" ref={fadeTitle.ref} $visible={fadeTitle.visible}>
                      <p className="font-pretendard">Horigul Story</p>
                      <h1>
                          신비로움이 깃든 동굴, <span>호리굴</span>
                      </h1>
                    </IntroTitle>
                    <IntroContent className="intro-content" ref={fadeContentLeft.ref} $visible={fadeContentLeft.visible}>
                        여행의 설렘, 눈부신 햇살 한 조각 <br />
                        녹음을 담은 향, 품격있는 공간<br />
                        호리굴 속 공존하는 쉼과 설렘<br />
                        <br />
                        바위, 나무, 자갈, 바다의 자연을 담았습니다.<br />
                        자연이 어우러진 공간에서<br />
                        여유를 만끽해 보시길 바랍니다.<br />
                    <br />
                    <p className="font-pretendard">STAY HORIGUL</p>
                    </IntroContent>
                    <MobileImgGrid>
                        <div className="row row-2to1">
                            <MobileFadeImg src={mbMainImage01} alt="호리굴 이미지" className="img1" ref={fadeMbImg01.ref as React.RefObject<HTMLImageElement>} $visible={fadeMbImg01.visible} />
                            <MobileFadeImg src={mbMainImage02} alt="호리굴 이미지" className="img2" ref={fadeMbImg02.ref as React.RefObject<HTMLImageElement>} $visible={fadeMbImg02.visible} />
                        </div>
                        <div className="row row-1to1_5">
                            <MobileFadeImg src={mbMainImage03} alt="호리굴 이미지" className="img3" ref={fadeMbImg03.ref as React.RefObject<HTMLImageElement>} $visible={fadeMbImg03.visible} />
                            <MobileFadeImg src={mbMainImage04} alt="호리굴 이미지" className="img4" ref={fadeMbImg04.ref as React.RefObject<HTMLImageElement>} $visible={fadeMbImg04.visible} />
                        </div>
                        <MobileFadeImg src={mbMainImage05} alt="호리굴 이미지" className="single left-margin" ref={fadeMbImg05.ref as React.RefObject<HTMLImageElement>} $visible={fadeMbImg05.visible} />
                        <MobileFadeImg src={mbMainImage06} alt="호리굴 이미지" className="single right-margin" ref={fadeMbImg06.ref as React.RefObject<HTMLImageElement>} $visible={fadeMbImg06.visible} />
                    </MobileImgGrid>
                </IntroText>
                <IntroImgWrap $sec01 className="intro-img sec01">
                        <IntroImg
                            src={mainImage01}
                            alt="호리굴 이미지"
                            $className="sec01-img01"
                            ref={fadeImg01.ref as React.RefObject<HTMLImageElement>}
                            $visible={fadeImg01.visible}
                        />
                        <IntroImg
                            src={mainImage02}
                            alt="호리굴 이미지"
                            $className="sec01-img02"
                            ref={fadeImg02.ref as React.RefObject<HTMLImageElement>}
                            $visible={fadeImg02.visible}
                        />
                        <IntroImg
                            src={mainImage03}
                            alt="호리굴 이미지"
                            $className="sec01-img03"
                            ref={fadeImg03.ref as React.RefObject<HTMLImageElement>}
                            $visible={fadeImg03.visible}
                        />
                </IntroImgWrap>
                </IntroGrid>
                <IntroGrid className="intro-sec02">
                <IntroImgWrap $sec02 className="intro-img sec02">
                        <IntroImg src={mainImage04} alt="호리굴 이미지" $className="sec02-img04" ref={fadeImg04.ref as React.RefObject<HTMLImageElement>} $visible={fadeImg04.visible} />
                        <IntroImg src={mainImage05} alt="호리굴 이미지" $className="sec02-img05" ref={fadeImg05.ref as React.RefObject<HTMLImageElement>} $visible={fadeImg05.visible} />
                        <IntroImg src={mainImage06} alt="호리굴 이미지" $className="sec02-img06" ref={fadeImg06.ref as React.RefObject<HTMLImageElement>} $visible={fadeImg06.visible} />
                        <IntroImg src={mainImage07} alt="호리굴 이미지" $className="sec02-img07" ref={fadeImg07.ref as React.RefObject<HTMLImageElement>} $visible={fadeImg07.visible} />
                </IntroImgWrap>
                <IntroText $right className="intro-text right">
                    <MobileOnlyLogo src={mobileLogo} alt="모바일 로고" />
                    <IntroContent className="intro-content" ref={fadeContentRight.ref} $visible={fadeContentRight.visible}>
                        동해의 수많은 항구 중 하나인 정자항 <br />
                        어촌 마을의 풍경을 담은 깊은 곳<br />
                        <br />
                        상상할 수 없는 작고 특별한 땅,<br />
                        하지만 큰 기억을 가진 자유로운 공간<br />
                        <br />
                        우리 모두의 추억에는<br className="mobile-br" /> 상상의 동굴이 하나쯤 있습니다.<br />
                        동해 바다와 맞닿은 이곳에서<br className="mobile-br" /> 발견하는 신비로운 동굴<br />
                        <br />
                        동굴 깊은 곳을 가득 채우는 상상의 빛은<br className="mobile-br" /> 하늘과 마주합니다.<br />
                        층층이 축적된 동굴의 시간은<br className="mobile-br" /> 호리호리한 공간의 경험을 선사합니다.<br />
                        <br />
                        자연과 인간이 만든<br className="mobile-br" /> 호리호리한 신비로운 동굴<br/>
                        내면의 자유와 새로운 상상을 <br className="mobile-br" />간직하게 되는 호리굴<br/>
                        <br />
                        건축가 정웅식
                    </IntroContent>
                    <MobileImg7 src={mbMainImage07} alt="호리굴 이미지" ref={fadeMbImg07.ref as React.RefObject<HTMLImageElement>} $visible={fadeMbImg07.visible} />
                </IntroText>
            </IntroGrid>
        </IntroSection>
    );
}

const IntroSection = styled.section`
  width: 100%;
`;
const IntroGrid = styled.div`
  height: 100vh;
  max-height: 1000px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 10rem 0;
  @media (max-width: 1024px) {
    height: auto;
    margin: 4rem 0 0 0;
  }
  @media (max-width: 768px) {
    max-height: none;
    grid-template-columns: 1fr;
    margin-top: 3.125rem;
  }
`;
const IntroText = styled.div<{ $left?: boolean; $right?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  ${(props) =>
    props.$left &&
    css`
      margin: 6rem 16rem 0 0;
      padding-left: 1rem;
      align-items: flex-end;
      @media (max-width: 1024px) {
        margin: 0;
        align-items: center;
        justify-content: flex-end;
      }
    `}
    @media (max-width: 768px) {
      padding-left: 0;
    }
  ${(props) =>
    props.$right &&
    css`
      margin-top: 5rem;
      align-items: flex-start;
      @media (max-width: 1024px) {
        margin: 0;
      }
      @media (max-width: 768px) {
        margin: 0;
        align-items: center;
      }
    `}
`;
const IntroTitle = styled(FadeInDiv)`
  p {
    color: #ffffff35;
    font-size: 1.125rem;
    font-weight: 300;
    font-family: 'Pretendard', sans-serif;
    @media (max-width: 768px) {
      display: none;
    }
  }
  h1 {
    font-size: 1.5rem;
    font-weight: 400;
    margin-bottom: 10rem;
    @media (max-width: 768px) {
      font-size: 1.125rem;
      margin-bottom: 1.25rem;
    }
    span {
      font-size: 2.25rem;
      @media (max-width: 768px) {
        font-size: 1.5rem;
      }
    }
  }
`;
const IntroContent = styled(FadeInDiv)`
  color: #ffffff85;
  font-size: 1.125rem;
  line-height: 2.375rem;
  p {
    font-size: 1rem;
    font-weight: 300;
    font-family: 'Pretendard', sans-serif;
  }
  @media (max-width: 768px) {
    font-size: 1rem;
    line-height: 1.5rem;
    text-align: center;
    p {
      display: none;
    }
  }
`;
const IntroImgWrap = styled.div<{ $sec01?: boolean; $sec02?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 40rem;
  overflow: hidden;
  @media (max-width: 768px) {
    display: none;
  }
`;
const IntroImg = styled(FadeInImg)<{ $className?: string }>`
  position: absolute;
  ${(props) =>
    props.$className === "sec01-img01" &&
    css`
      top: 6rem;
      left: 0;
    `}
  ${(props) =>
    props.$className === "sec01-img02" &&
    css`
      top: 18.5rem;
      left: 29rem;
    `}
  ${(props) =>
    props.$className === "sec01-img03" &&
    css`
      top: 1rem;
      left: 29rem;
    `}
  ${(props) =>
    props.$className === "sec02-img04" &&
    css`
      right: 3rem;
    `}
  ${(props) =>
    props.$className === "sec02-img05" &&
    css`
      top: 16rem;
      right: 31rem;
    `}
  ${(props) =>
    props.$className === "sec02-img06" &&
    css`
      @media (max-width: 768px) {
        display: block;
      }
      display: none;
    `}
  ${(props) =>
    props.$className === "sec02-img07" &&
    css`
      @media (max-width: 768px) {
        display: block;
      }
      display: none;
    `}
  @media (max-width: 768px) {
    position: static !important;
    display: none !important;
  }
`;
const MobileImgGrid = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin: 2rem 0 0 0;
    width: 100%;
    .row {
      display: flex;
      width: 100%;
      gap: 0.75rem;
      align-items: flex-end;
    }
    .row-2to1 {
      .img1 {
        flex: 1.5;
        width: 0;
        min-width: 0;
        object-fit: cover;
      }
      .img2 {
        flex: 1;
        width: 0;
        min-width: 0;
        object-fit: cover;
      }
    }
    .row-1to1_5 {
      .img3 {
        flex: 1;
        width: 0;
        min-width: 0;
        object-fit: cover;
        margin-bottom: -9rem;
      }
      .img4 {
        flex: 1.5;
        width: 0;
        min-width: 0;
        object-fit: cover;
      }
    }
    .single {
      width: 100%;
      height: auto;
      object-fit: cover;
      &.left-margin {
        width: calc(100% - 2rem);
        margin: 9rem 0 0 2rem;
      }
      &.right-margin {
        width: calc(100% - 2rem);
        margin-right: 2rem;
      }
    }
  }
`;
const MobileImg7 = styled.img.withConfig({ shouldForwardProp: prop => prop !== '$visible' })<{ $visible: boolean }>`
  display: none;
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    margin: 2rem 0 0 0;
    object-fit: cover;
  }
`;
const MobileFadeImg = styled.img.withConfig({ shouldForwardProp: prop => prop !== '$visible' })<{ $visible: boolean }>`
  width: 100%;
  height: auto;
  object-fit: cover;
  transition: opacity 0.6s, transform 0.6s;
  opacity: ${props => (props.$visible ? 1 : 0)};
  transform: translateY(${props => (props.$visible ? '0' : '40px')});
  &.left-margin {
    width: calc(100% - 2rem);
    margin: 9rem 0 0 2rem;
  }
  &.right-margin {
    width: calc(100% - 2rem);
    margin-right: 2rem;
  }
`;
const MobileOnlyLogo = styled.img`
  width: fit-content;
  height: fit-content;
  display: none;
  object-fit: cover;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    display: block;
  }
`;